import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { useNavigate } from 'react-router-dom';
import { useModalExtra, useHideExtraModal } from './ModalHooks';
import LogoBabastudio from '../../asset/Logo_Babastudio.png';
import LogoTechfor from '../../asset/Logo_Techfor.png';
import LogoSekolahpintar from '../../asset/Logo_SekolahPintar.png';
import {api} from '../../redux/config';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  hover: {
    cursor: 'pointer'
  },
  img: {
    [theme.breakpoints.down('xs')]: {
      width: '140px'
    },
    maxWidth: '250px',
    maxHeight: '56px',
  },
  title: {
    marginLeft: theme.spacing(2),
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenDialog() {
  const classes = useStyles();
  const navigate = useNavigate();

  const modal = useModalExtra().modalExtra.payload.extraModalReducer;
  const { handleOnCloseExtra } = useHideExtraModal();

     // event handler menu logout
  const handleLogOut = () => {
    api.post('oauth/logout') // panggil endpoint oauth/logout backend
    .then(response => {
      // console.log("SUCCESS LOGOUT")
      sessionStorage.clear();
      localStorage.clear();
      window.location.assign('/'); //redirect ke halaman home
      handleOnCloseExtra();
    })
    .catch(result => {
      // console.log("FAILED LOGOUT")
      sessionStorage.clear();
      localStorage.clear();
      window.location.assign('/');
      handleOnCloseExtra();
    })
  };

  const handleNavigate = (path) => {
    handleOnCloseExtra();
    navigate(path)
  };

  const getDynamicImage = () => {
    if(process.env.REACT_APP_PLATFORM === "Babastudio"){
        return LogoBabastudio
    } else if (process.env.REACT_APP_PLATFORM === "SekolahPintar") {
        return LogoSekolahpintar
    } else if (process.env.REACT_APP_PLATFORM === "Techfor.id") {
        return LogoTechfor
    } else {
        return null
    }
  };
  
  return (
    <div>
      <Dialog fullScreen open={modal.showExtra && modal.fullscreen} onClose={handleOnCloseExtra} TransitionComponent={Transition}>
        <AppBar className={classes.appBar} color="white">
          <Toolbar>
            <img onClick={() => window.location.assign('/')} className={clsx(classes.hover, classes.img)} src={getDynamicImage()} width={250} alt={process.env.REACT_APP_MAIN_URL}/>
            <div style={{flex: 1}} />
            <IconButton edge="end" color="inherit" onClick={handleOnCloseExtra} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        {localStorage.loggedInUserBabaPrakerja ?
        <List>
          <ListItem button onClick={() => handleNavigate('/')}>
            <ListItemText primary="Home"/>
          </ListItem>
          <Divider />
          <ListItem button onClick={() => handleNavigate('/my-profile')}>
            <ListItemText  primary="Profil" />
            <NavigateNextIcon style={{textAlign: "right"}}/>
          </ListItem>
          <Divider />
          {/* <ListItem button onClick={() => handleNavigate('/tabungan-penunjang-karir')}>
            <ListItemText primary="Tabungan Penunjang Karir" />
            <NavigateNextIcon style={{textAlign: "right"}}/>
          </ListItem>
          <Divider /> */}
          {/* menu logout dengan event handler handleLogOut*/}
          <ListItem button onClick={handleLogOut}>
            <ListItemText primary="Keluar" />
            <NavigateNextIcon style={{textAlign: "right"}}/>
          </ListItem>
        </List> :
        <List>
          <ListItem button onClick={() => handleNavigate('/')}>
            <ListItemText primary="Home"/>
          </ListItem>
          <Divider />
          <ListItem button onClick={() => handleNavigate('/login')}>
            <ListItemText primary="Masuk" />
            <NavigateNextIcon style={{textAlign: "right"}}/>
          </ListItem>
          <Divider />
          <ListItem button onClick={() => handleNavigate('/register')}>
            <ListItemText primary="Daftar" />
            <NavigateNextIcon style={{textAlign: "right"}}/>
          </ListItem>
          <Divider />
          <ListItem button onClick={() => handleNavigate('/faq')}>
            <ListItemText primary={`Panduan Website ${process.env.REACT_APP_PLATFORM}`} />
            <NavigateNextIcon style={{textAlign: "right"}}/>
          </ListItem>
          <Divider />
          <ListItem button onClick={() => handleNavigate('/tanya-cs')}>
            <ListItemText primary="Konsultasi dengan CS" />
            <NavigateNextIcon style={{textAlign: "right"}}/>
          </ListItem>
          <Divider />
        </List>}
      </Dialog>
    </div>
  );
}

